import { React, useState, useEffect } from 'react';
import styled from 'styled-components';

export default function PointHistoryColumn() {

  return (
    <TopLevelWrapper>
      <Column style={{marginRight: '283px', marginLeft: '28px'}}>적용 내용</Column>
      <Column style={{marginRight: '425px'}}>적용일</Column>
      <Column>포인트</Column>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;
  
  justify-content: flex-start;
  align-items: center;

  width: 1020px;
  margin-top: 16px;
  margin-bottom: 20px;
  
  transition: all 0.3s ease-in-out;
`;

const Column = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #232323;

  margin: 0 0 0 0;
`;
